/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    ON_PLACE: 'onPlace',
    CARD: 'card',
    CREDIT: 'credit',
    PASS: 'pass',
    BANK_ACCOUNT: 'bankAccount',
    BENEFIT: 'benefit',
    OTHER: 'other',
    BENEFIT_AND_OTHER: 'benefitAndOther',
};
